/* eslint-disable */
<template>
  <div
    class="header flex"
    ref="header"
  >
    <div class="left flex">
      <img
        class="back"
        @click="goto('/menus/menus')"
        src="@/assets/images/index/back@2x.png"
      />
      <span class="bar"></span>
      <img
        class="logo"
        src="@/assets/images/index/logo.jpg"
      />
      <span class="title">{{pageOption.corporateNameChinese}}</span>
      <span class="bar"></span>
      <a-dropdown
        :trigger="['click']"
        overlayClassName="a-dropdown"
        :getPopupContainer="()=>$refs.header"
      >
        <a
          class="ant-dropdown-link"
          @click.prevent
        >
          主菜单
        </a>
        <template #overlay>
          <a-menu>
            <template v-for="(item, i) in userRouters">
              <a-menu-item
                v-if="!item.alwaysShow"
                @click="goto(item.path, item.name)"
              >{{item.name}}</a-menu-item>
            </template>
            <template v-for="(item, i) in userRouters">
              <a-sub-menu
                v-if="item.alwaysShow"
                :key="i"
                :title="item.name"
              >
                <template v-for="(child, j) in item.children">
                  <a-menu-item
                    v-if="!child.alwaysShow"
                    @click="goto(child.path, child.name)"
                  >{{child.name}}</a-menu-item>
                </template>
                <template v-for="(child, m) in item.children">
                  <a-sub-menu
                    v-if="child.alwaysShow"
                    :title="child.name"
                  >
                    <template v-for="(child2, n) in child.children">
                      <a-menu-item
                        v-if="!child2.alwaysShow"
                        @click="goto(child2.path, child2.name)"
                      >{{child2.name}}</a-menu-item>
                    </template>
                  </a-sub-menu>
                </template>
              </a-sub-menu>
            </template>
          </a-menu>
        </template>
      </a-dropdown>
      <a-breadcrumb>
        <a-breadcrumb-item>&nbsp;</a-breadcrumb-item>
        <a-breadcrumb-item>{{name}}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="right flex">
      <!-- <img
        class="search"
        src="@/assets/images/index/icon-ss@2x.png"
      /> -->
      <a-badge
        :count="count"
        show-zero
      >
        <img
          class="news"
          @click="goto('/alarms/message/message', '站内消息 / 预警信息')"
          src="@/assets/images/index/icon-ld@2x.png"
        />
      </a-badge>
      <span class="bar"></span>
      <Headimg />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { HomeOutlined } from "@ant-design/icons-vue";
import Headimg from "@/components/header/headimg.vue";
import { alarmNUm } from "@/api/warning/warning.js";

export default {
  name: "header",
  components: {
    HomeOutlined,
    Headimg,
  },
  data() {
    return {
      menu: [],
      name: '',
      count: '',
      timing: '',
      userRouters: [],
      pageOption: {}
    }
  },
  props: ['presentPage'],
  updated() {
    this.name = this.presentPage
  },
  beforeUnmount() {
    clearInterval(this.timing)
  },
  mounted() {
    this.count = localStorage.getItem('warningNum')
    var _this = this
    this.timing = setInterval(function() {
      _this.init()
    }, 10000)
    this.userRouters = JSON.parse(localStorage.getItem('userRouters'))
    this.pageOption = JSON.parse(localStorage.getItem('pageOption'))
  },
  methods: {
    goto(path, name, develop) {
      if (name == '大屏显示') {
        // this.$message.info('正在开发');
        this.goto2(path)
      } else {
        this.$router.push({ path: path, query: { name: name } }, () => { }).catch(res => {
          console.log(res)
        });
      }
    },
    goto2(path) {
      const newPage = this.$router.resolve({ name: 'LargeScreen' })
      console.log(newPage)
      window.open(newPage.href, '_blank');
    },
    init() {
      alarmNUm().then(res => { //预警信息统计
        if (res.code == 200) {
          this.count = res.data
          localStorage.setItem('warningNum', this.count)
        }
      })
    },
  }
};
</script>

<style scoped>
.header {
  justify-content: space-between;
  padding: 0 30px;
  height: 50px;
  background: #141414 url(~@/assets/images/index/bg@2x.png) no-repeat center;
  background-size: 100% 100%;
}
.left {
  height: 50px;
  justify-content: start;
}
.back {
  width: 28px;
}
.logo {
  width: 42px;
  height: 36px;
  margin-right: 8px;
}
.title {
  font-size: 24px;
  color: #fff;
  font-weight: 600;
}
.ant-dropdown-link {
  color: #fff;
}
.header :deep() .a-dropdown {
  width: 130px;
  border-radius: 8px;
}
.header :deep() .ant-dropdown-menu {
  padding: 0;
}
.header :deep() .a-dropdown .ant-dropdown-menu-item,
.header :deep() .a-dropdown .ant-dropdown-menu-submenu-title {
  font-family: PingFang SC;
  border-bottom: 1px solid #eee;
}
.header :deep() .ant-dropdown-menu-submenu {
  width: 130px;
}
.header :deep() .ant-dropdown-menu-submenu .ant-dropdown-menu-item {
  border-left: 2px solid #fff;
}
.header :deep() .ant-dropdown-menu-submenu .ant-dropdown-menu-item:hover {
  border-left: 2px solid #0088ff;
  background: linear-gradient(
    to right,
    rgb(0, 136, 255, 0.2),
    rgb(255, 255, 255, 0.2)
  );
}
.ant-breadcrumb :deep() span {
  color: #0088ff;
}
.right {
  height: 50px;
  justify-content: end;
  color: #fff !important;
  line-height: 1;
}
.search,
.news {
  width: 20px;
}
.right :deep() .ant-badge-count {
  min-width: 16px;
  height: 16px;
  line-height: 16px;
  padding: 0;
}
.ant-breadcrumb-link,
.ant-breadcrumb-separator {
  color: #0088ff;
}
</style>
